<mat-table
  id="integrations_table"
  class="custom-table tab-custom-table"
  matSort
  matSortActive="vendorName"
  matSortDirection="asc"
  matSortDisableClear
  [dataSource]="sortedData()"
  (matSortChange)="selectSort($event)">
  <ng-container matColumnDef="vendorName">
    <mat-header-cell
      id="integrations_table_name"
      mat-sort-header
      class="name-column"
      *matHeaderCellDef>
      <span class="custom-header pointer" id="integrations_name_text">Vendor</span>
    </mat-header-cell>
    <mat-cell id="name" class="name-column" *matCellDef="let element">
      <span id="name_element">
        {{ element.vendorName }}
      </span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="vendorKey">
    <mat-header-cell
      id="integrations_table_vendor_key"
      mat-sort-header
      class="vendor-key-column"
      *matHeaderCellDef>
      <span class="custom-header pointer" id="integrations_vendor_key_text">Key</span>
    </mat-header-cell>
    <mat-cell id="integrations_vendor_key_cell" class="vendor-key-column" *matCellDef="let element">
      <span id="integrations_vendor_key_element">{{ element.vendorKey }}</span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="integrationType">
    <mat-header-cell
      id="integrations_table_integration_type"
      mat-sort-header
      class="integration-type-column"
      *matHeaderCellDef>
      <span class="custom-header pointer" id="integrations_integration_type_text">Type</span>
    </mat-header-cell>
    <mat-cell
      id="integrations_vendor_integration_type_cell"
      class="integration-type-column"
      *matCellDef="let element">
      <span id="integrations_integration_type_element">{{ element.integrationType }}</span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="pushUrl">
    <mat-header-cell id="integrations_table_pushUrl" class="push-url-column" *matHeaderCellDef>
      <span class="custom-header pointer" id="integrations_table_pushUrl_text">Endpoint</span>
    </mat-header-cell>
    <mat-cell id="integrations_table_pushUrl" class="push-url-column" *matCellDef="let element">
      <span class="truncate hyperlink" id="integrations_table_pushUrl_element">
        {{ element.pushUrl }}</span
      >
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="customers">
    <mat-header-cell id="integrations_table_customer_list" class="list-column" *matHeaderCellDef>
      <span class="custom-header pointer" id="integrations_table_customer_list_header"
        >Customer Access
      </span>
    </mat-header-cell>
    <mat-cell
      id="integrations_table_customer_list_cell"
      class="list-column"
      *matCellDef="let element">
      <span
        class="list-column-element truncate"
        matTooltipClass="custom-tooltip"
        [matTooltip]="element.customers | tooltipList"
        [matTooltipShowDelay]="250">
        @if (element.customers.length === 0) {
          <span>-</span>
        }
        @for (customer of element.customers; track customer; let i = $index) {
          <span id="integrations_table_customer_list_element" class="customer-list">
            {{ customer.customerKey }}
            @if (i !== element.customers.length - 1) {
              <span>,</span>
            }
          </span>
        }
      </span>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="status">
    <mat-header-cell
      id="integrations_table_status"
      class="just-center status-column"
      mat-sort-header
      *matHeaderCellDef>
      <span class="custom-header pointer" id="integrations_table_status_header">Status</span>
    </mat-header-cell>
    <mat-cell
      id="integrations_table_status_header_cell"
      class="just-center status-column"
      *matCellDef="let element">
      <div
        class="{{ element.enabled === true ? 'active-status' : 'inactive-status' }} common-status"
        align="center">
        <span
          class="{{ element.enabled === true ? 'active-status-text' : 'inactive-status-text' }}"
          id="integrations_table_status_element"
          align="center">
          {{ element.enabled === true ? 'Enabled' : 'Disabled' }}
        </span>
      </div>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="actions">
    <mat-header-cell
      id="integrations_table_actions"
      class="just-center actions-column"
      *matHeaderCellDef>
      <span id="integrations_table_actions_header" class="custom-header">Actions</span>
    </mat-header-cell>
    <mat-cell
      id="integrations_table_actions_cell"
      class="just-center actions-column"
      *matCellDef="let element">
      <button
        mat-button
        id="integrations_table_edit"
        class="action-button white-button"
        [routerLink]="[
          '/integrations',
          integrationCategory().toLowerCase(),
          action.edit,
          element.id,
        ]">
        Edit
      </button>
    </mat-cell>
  </ng-container>
  <mat-header-row
    id="integrations_mat_header_row"
    class="op-api-header-row"
    *matHeaderRowDef="displayedColumns; sticky: true">
  </mat-header-row>
  <mat-row id="integrations_mat_row" *matRowDef="let row; columns: displayedColumns"> </mat-row>
</mat-table>
@if (resultsLength() > 0) {
  <mat-paginator
    #paginator
    id="integrations_paginator"
    class="custom-mat-paginator"
    [length]="resultsLength()"
    [pageIndex]="pageIndex()"
    [pageSize]="50"
    [pageSizeOptions]="[50, 100, 250]"
    (page)="handlePageEvent($event)">
  </mat-paginator>
}
<div class="no-record">
  @if (resultsLength() === 0 && loading() === false && error() === false) {
    <div id="no_data" class="no-data">
      <img
        id="integrations_noDataImage"
        src="/assets/images/no_data.svg"
        alt="No Record"
        width="100" />
      <h1 id="integrations_noDataText">No Data</h1>
      <p id="integrations_noDataContent" class="custom-p">Let's get started shall we?</p>
    </div>
  }
  @if (!loading() && error()) {
    <app-form-error />
  }
  @if (loading()) {
    <app-loading-spinner />
  }
</div>
